import React, { useState, useEffect, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Panel } from 'react-bootstrap'
import { withTheme } from 'styled-components'
import scrollToElement from 'scroll-to-element'
import FAQPanel from './FAQPanel'
import FAQContent from './FAQContent'

import arr from '../../assets/images/arr.svg'

function* generatorFunction(index = 1) {
  while (true) {
    yield index++
  }
}

const gen = generatorFunction()

const FAQ = ({
  categories,
  toggleFaq,
  createUserEvent,
  activeFaqId,
  modalOpen,
  isSameFaq
}) => {
  const [categorizedFAQs, setCategorizedFAQs] = useState([])
  const [uncategorizedFAQs, setUncategorizedFAQs] = useState([])

  const isOpenFaq = faq => parseInt(faq.pk, 10) === parseInt(activeFaqId, 10) && !isSameFaq

  useEffect(() => {
    setCategorizedFAQs(
      categories.filter(category => category.name !== 'Parent Category')
    )
    setUncategorizedFAQs(
      categories.filter(category => category.name === 'Parent Category')
    )
  }, [categories])

  useEffect(() => {
    if (!modalOpen && activeFaqId) {
      setTimeout(() => {
        window.requestAnimationFrame(() => {
          scrollToElement('.active', {
            offset: -5,
            duration: 1000
          })
          document.querySelector('.active .panel-body a')?.focus()
        })
      }, 0)
    }
  }, [activeFaqId, modalOpen])

  return (
    <Fragment>
      {categorizedFAQs.map((val, i) => (
        <FAQPanel
          key={`faq-primary-${i}`}
          panelClassName="faq-primary faq-category"
          headingStyle={{
            background: 'var(--clr-bg)',
            borderBottom: '0'
          }}
          tabIndex={gen.next().value}
          toggleClassName="toggle"
          name={val.name}
          iconSrc={arr}
          open={
            val.children.findIndex(subcat =>
              subcat.children.find(
                faq => parseInt(faq.pk, 10) === parseInt(activeFaqId, 10)
              )
            ) > -1
          }
          createUserEvent={createUserEvent}
          category="faqs"
          action="TogglePrimaryCategory"
          target={val.name}
          bodyStyle={{ background: 'var(--clr-bg)' }}
        >
          {val.children.map((subval, j) =>
            subval.name !== val.name || val.children.length > 1 ? (
              <FAQPanel
                key={`faq-secondary-${j}`}
                panelClassName="faq-category"
                headingStyle={{
                  background: 'var(--clr-bg)',
                  borderBottom: '0'
                }}
                tabIndex={gen.next().value}
                toggleClassName="toggle"
                name={`— ${subval.name}`}
                iconSrc={arr}
                open={
                  subval.children.findIndex(
                    faq => parseInt(faq.pk, 10) === parseInt(activeFaqId, 10)
                  ) > -1
                }
                createUserEvent={createUserEvent}
                category="faqs"
                action="ToggleSecondaryCategory"
                target={subval.name}
              >
                {subval.children.map((faq, k) => (
                  <FAQPanel
                    key={`faq-tertiary-${k}`}
                    panelClassName="faq-panel"
                    tabIndex={gen.next().value}
                    name={faq.name}
                    open={isOpenFaq(faq)}
                    createUserEvent={createUserEvent}
                    faqId={faq.pk}
                    toggleFaq={toggleFaq}
                  >
                    <FAQContent
                      name={faq.name}
                      text={faq.val}
                      faqId={faq.pk}
                      createUserEvent={createUserEvent}
                    />
                  </FAQPanel>
                ))}
              </FAQPanel>
            ) : (
              subval.children.map((faq, k) => (
                <FAQPanel
                  key={`faq-default-${k}`}
                  panelClassName="faq-panel"
                  tabIndex={gen.next().value}
                  name={faq.name}
                  open={isOpenFaq(faq)}
                  createUserEvent={createUserEvent}
                  faqId={faq.pk}
                  toggleFaq={toggleFaq}
                >
                  <FAQContent
                    name={faq.name}
                    text={faq.val}
                    faqId={faq.pk}
                    createUserEvent={createUserEvent}
                  />
                </FAQPanel>
              ))
            )
          )}
        </FAQPanel>
      ))}

      {uncategorizedFAQs.length > 0 &&
        uncategorizedFAQs[0].children[0].children.map((faq, i) => (
          <FAQPanel
            key={`faq-uncategorized-default-${i}`}
            panelClassName="faq-panel"
            tabIndex={i}
            name={faq.name}
            open={isOpenFaq(faq)}
            createUserEvent={createUserEvent}
            faqId={faq.pk}
            toggleFaq={toggleFaq}
            hideCategories
          >
            <Panel.Body>
              <FAQContent
                name={faq.name}
                text={faq.val}
                faqId={faq.pk}
                createUserEvent={createUserEvent}
              />
            </Panel.Body>
          </FAQPanel>
        ))}
    </Fragment>
  )
}

FAQ.propTypes = {
  categories: PropTypes.array.isRequired,
  toggleFaq: PropTypes.func.isRequired,
  createUserEvent: PropTypes.func.isRequired,
  activeFaqId: PropTypes.number,
  modalOpen: PropTypes.bool
}

export default withTheme(FAQ)



// WEBPACK FOOTER //
// ./src/components/FAQ/FAQ.js